export default __webpack_public_path__ + "media/images/rules-dog-c7d31826090222cb3f46b417df2dc357.svg";